/**
 * start-aggregator-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { AggregatorDescriptor }
  from "../../../aggregation/aggregator-descriptor";
import { CollectionType, ServerDataType }
  from "../../../common/data/data-types";
import { SubjectContextType } from "../../../subjects/subject-context-type";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export interface AggregationFilterNode
{
  nodeType : "variable" | "constant" | "operator" | "argument";

  operator? : string;
  operands? : AggregationFilterNode[];

  value? : any;
  type? : ServerDataType;
  collectionType? : CollectionType;
  cardinality? : number;

  variable? : string;
}

export class StartAggregatorRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_START_AGGREGATOR;
	public static tag : MessageTag = MessageTag.REQ_START_AGGREGATOR;

  /**
   * Construct a new {@link StartAggregatorRequest}.
   */
  constructor (
    public aggregationId : number,
    public filterTree : AggregationFilterNode,
    public targetVariable? : string,
    public rerun : boolean = false
  )
  {
    super();
    if (!targetVariable)
    {
      delete this.targetVariable;
    }
    if (!filterTree)
    {
      delete this.filterTree;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/aggregation/start-aggregator-request.ts